import { MOSCOW_AND_MO_IDS, SPB_AND_LO_IDS } from './region';

/** Фичетогл акции «30 000 ₽ за покупку квартиры» */
export const NEWBUILDING_PURCHASE_GIFT_ENABLED_KEY = 'Newbuilding.PurchaseGiftPromo.Enabled';
/** Почта, на которую покупатель присылает письмо для участия в акции */
export const NEWBUILDING_PURCHASE_GIFT_EMAIL_KEY = 'Newbuilding.PurchaseGiftPromo.Email';
/** Ссылка на страницу условий акции */
export const NEWBUILDING_PURCHASE_GIFT_TERMS_URL_KEY = 'Newbuilding.PurchaseGiftPromo.TermsUrl';

/** Регионы ЖК, в которых показываются точки входа акции */
export const NEWBUILDING_PURCHASE_GIFT_REGIONS: number[] = [...MOSCOW_AND_MO_IDS, ...SPB_AND_LO_IDS];

export const NEWBUILDING_PURCHASE_GIFT_BANNER_TITLE = 'Купите квартиру и получите 30 000 ₽';
export const NEWBUILDING_PURCHASE_GIFT_BANNER_SUBTITLE =
  'Деньги получат первые 100 покупателей новостроек — узнайте, как поучаствовать';
export const NEWBUILDING_PURCHASE_GIFT_BANNER_LINK_TEXT = 'Подробнее';
export const NEWBUILDING_PURCHASE_GIFT_HEADER_LABEL_TEXT = 'Получите 30 000 ₽ за звонок';
